import getStateValue from '../getStateValue';

/**
 * Function for get Reseller id.
 * @return {string}
 */
const getResellerId = () => getStateValue('resellerId');

export default getResellerId;
